// extracted by mini-css-extract-plugin
module.exports = {"root":"SignUpComponent_root__ZrRc5"};